module.exports = __webpack_public_path__ + "7e4b29ba/img/settings-icon.121d9519.svg";